import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.trim.js";
import { defineComponent as _defineComponent } from 'vue';
import * as Diff from 'diff';
import { computed, ref, watch, getCurrentInstance } from 'vue';
import LIST_METRICS_QUERY from '~/graphql/queries/ListMetrics.gql';
import { MetricAggregationMethod, MetricValueKind, TypeMetricAssignedTo, useListSectionsQuery, useUpsertMetricMutation, useValidateFormulaMutation, AnnualAggregationMethod, MetricReportingPeriodType, useGetUserQuery } from '~/types/types';
import { useShowDebugging } from '~/functions/accounts';
import { renderMarkdown } from '~/functions/markdown';
export default /*#__PURE__*/_defineComponent({
  __name: 'kpiEdit',
  props: {
    item: null,
    isTocImpactCarryContext: {
      type: Boolean
    }
  },
  emits: ['input', 'upsert'],
  setup: function setup(__props, _ref) {
    var _nuxt2Context$app, _nuxt2Context$app$apo;
    var emit = _ref.emit;
    var props = __props;
    var showDebugging = useShowDebugging();
    var nuxtApp = useNuxtApp();
    var _getCurrentInstance = getCurrentInstance(),
      proxy = _getCurrentInstance.proxy;
    var _useGetUserQuery = useGetUserQuery(),
      userResult = _useGetUserQuery.result;
    var user = computed(function () {
      var _userResult$value;
      return ((_userResult$value = userResult.value) === null || _userResult$value === void 0 ? void 0 : _userResult$value.getUser) || {
        locale: 'en-US',
        isAdmin: false
      };
    });
    var showAdmins = computed(function () {
      var _user$value;
      return ((_user$value = user.value) === null || _user$value === void 0 ? void 0 : _user$value.isAdmin) || showDebugging.value;
    });
    var kpiEditTitle = computed(function () {
      var it = props.item;
      if (it && it.id != null) {
        return (proxy === null || proxy === void 0 ? void 0 : proxy.$t('edit')) + ': (' + it.id + ') ' + (it.name || '');
      }
      return proxy === null || proxy === void 0 ? void 0 : proxy.$t('add');
    });
    var editedItem = ref(structuredClone(props.item));
    var useJsonEditorForValueOptions = ref(false);
    var unitNameSearchInput = ref(typeof editedItem.value.unitName === 'string' ? editedItem.value.unitName : '');
    var setDefaults = function setDefaults() {
      if (editedItem.value.categoryId === undefined) {
        editedItem.value.categoryId = null;
      }
      if (editedItem.value.assignedTo === undefined) {
        editedItem.value.assignedTo = TypeMetricAssignedTo.Company;
      }
      if (editedItem.value.isComputed === null || editedItem.value.isComputed === undefined) {
        editedItem.value.isComputed = false;
      }
      if (editedItem.value.defaultReportingPeriodType === null || editedItem.value.defaultReportingPeriodType === undefined) {
        editedItem.value.defaultReportingPeriodType = MetricReportingPeriodType.Annual;
      }
      if (editedItem.value.allowCustomOptions === null || editedItem.value.allowCustomOptions === undefined) {
        editedItem.value.allowCustomOptions = false;
      }
      if (!editedItem.value.annualAggregationMethod) {
        editedItem.value.annualAggregationMethod = editedItem.value.allowQuarterlyInput ? AnnualAggregationMethod.Sum : AnnualAggregationMethod.MostRecent;
      }
    };
    setDefaults();
    watch(function () {
      return props.item;
    }, function (value) {
      // sync prop changes.
      editedItem.value = structuredClone(value);
      unitNameSearchInput.value = typeof (value === null || value === void 0 ? void 0 : value.unitName) === 'string' ? value.unitName : '';
      setDefaults();
      validatedFormula.value = {};
    });
    var _useUpsertMetricMutat = useUpsertMetricMutation(),
      mutate = _useUpsertMetricMutat.mutate;
    var isJsonString = function isJsonString(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    };
    var isConditionsInvalid = computed(function () {
      var _editedItem$value;
      var value = (_editedItem$value = editedItem.value) === null || _editedItem$value === void 0 ? void 0 : _editedItem$value.conditions;
      if (Array.isArray(value)) {
        return false;
      }
      if (typeof value === 'string') {
        if (!isJsonString(value)) {
          return true;
        }
        return !Array.isArray(JSON.parse(value));
      }
      return value !== undefined && value !== null;
    });
    var updateCategoryId = function updateCategoryId(v) {
      editedItem.value = _objectSpread(_objectSpread({}, editedItem.value), {}, {
        categoryId: v
      });
    };
    var save = function save() {
      var item = editedItem.value;
      // TODO fix this(when user chose TEXT in the editor, it will return a STRING)
      // const formula = isJsonString(item.formula)
      //   ? JSON.parse(item.formula)
      //   : item.formula

      var input = {
        id: item.id
      };
      var normalizeUnitName = function normalizeUnitName(value) {
        return typeof value === 'string' ? value.trim() : '';
      };
      for (var _i = 0, _Object$keys = Object.keys(changesByKey.value); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        if (['conditions', 'externalData'].includes(key)) {
          input[key] = isJsonString(item[key]) ? JSON.parse(item[key]) : item[key];
          // FIXME this is another place we have to do a special handling, I haven't figure out the best way yet with JSON-Editor because sometime is returns JSON sometimes STRING
        } else if (key === 'sections') {
          input.sectionIds = (item.sections || []).map(function (s) {
            return s.id;
          });
        } else {
          input[key] = item[key];
        }
      }
      input.unitName = normalizeUnitName(item.unitName) || normalizeUnitName(unitNameSearchInput.value);
      mutate({
        input: input
      }).then(function (val) {
        var _val$data, _val$data$upsertMetri;
        window.$nuxt.$emit('userMsg');
        emit('upsert', val === null || val === void 0 ? void 0 : (_val$data = val.data) === null || _val$data === void 0 ? void 0 : (_val$data$upsertMetri = _val$data.upsertMetric) === null || _val$data$upsertMetri === void 0 ? void 0 : _val$data$upsertMetri.id);
        emit('input', false);
      });
    };
    var _useListSectionsQuery = useListSectionsQuery({
        filters: {
          linkedToMetrics: true
        },
        limit: 1000 // we have only around 90 "indicator sets"
      }),
      sectionResult = _useListSectionsQuery.result;
    var allSections = computed(function () {
      var _sectionResult$value$, _sectionResult$value;
      return (_sectionResult$value$ = (_sectionResult$value = sectionResult.value) === null || _sectionResult$value === void 0 ? void 0 : _sectionResult$value.listSections) !== null && _sectionResult$value$ !== void 0 ? _sectionResult$value$ : [];
    });
    var formulaInHtml = computed(function () {
      var _editedItem$value2;
      var content = "<!-- ".concat(editedItem.value.id, " -->");
      var _iterator = _createForOfIteratorHelper(((_editedItem$value2 = editedItem.value) === null || _editedItem$value2 === void 0 ? void 0 : _editedItem$value2.humanReadableDirectFormula) || []),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var op = _step.value;
          if (op.type === 'VARIABLE') {
            content += "<span data-type=\"mention\" data-label=\"".concat(formatKPIName(op.variable), "\" data-id=\"").concat(op.variable.id, "\"></span>");
          } else {
            content += " ".concat(op.value, " ");
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return content;
    });
    var formulaErr = ref();
    var _useValidateFormulaMu = useValidateFormulaMutation(),
      validate = _useValidateFormulaMu.mutate;
    var validatedFormula = ref({
      formula: null,
      humanReadable: [],
      error: ''
    });
    var onFormulaInput = function onFormulaInput(expr) {
      if (!expr || expr === ' ' || expr.trim() === '') {
        editedItem.value.formula = null;
        formulaErr.value = null;
        validatedFormula.value = {
          formula: null,
          humanReadable: [],
          error: ''
        };
        return;
      }
      validate({
        expression: expr
      }).then(function (resp) {
        var _resp$data, _resp$data$validateFo, _data$validateFormula;
        var data = resp === null || resp === void 0 ? void 0 : resp.data;
        if (!data) {
          return;
        }
        formulaErr.value = (_resp$data = resp.data) === null || _resp$data === void 0 ? void 0 : (_resp$data$validateFo = _resp$data.validateFormula) === null || _resp$data$validateFo === void 0 ? void 0 : _resp$data$validateFo.error;
        validatedFormula.value = (data === null || data === void 0 ? void 0 : data.validateFormula) || {
          formula: null,
          humanReadable: [],
          error: ''
        };
        editedItem.value.formula = (_data$validateFormula = data.validateFormula) === null || _data$validateFormula === void 0 ? void 0 : _data$validateFormula.formula;
      });
    };
    var isCalculatedWithoutFormula = computed(function () {
      var _editedItem$value3, _editedItem$value4, _editedItem$value5;
      return ((_editedItem$value3 = editedItem.value) === null || _editedItem$value3 === void 0 ? void 0 : _editedItem$value3.isComputed) && (!((_editedItem$value4 = editedItem.value) !== null && _editedItem$value4 !== void 0 && _editedItem$value4.formula) || ((_editedItem$value5 = editedItem.value) === null || _editedItem$value5 === void 0 ? void 0 : _editedItem$value5.formula) === '');
    });

    /** Warn only when editing an existing KPI and the persisted annual aggregation method changed — not on create/default hydration. */
    var showAnnualAggregationMethodWarning = computed(function () {
      var _props$item;
      if (!showAdmins.value) return false;
      if (((_props$item = props.item) === null || _props$item === void 0 ? void 0 : _props$item.id) == null) return false;
      var original = props.item.annualAggregationMethod;
      if (!original) return false;
      return editedItem.value.annualAggregationMethod !== original;
    });
    var hasValueOptions = computed(function () {
      var _editedItem$value6, _editedItem$value6$va;
      var options = (_editedItem$value6 = editedItem.value) === null || _editedItem$value6 === void 0 ? void 0 : (_editedItem$value6$va = _editedItem$value6.valueOptions) === null || _editedItem$value6$va === void 0 ? void 0 : _editedItem$value6$va.options;
      return Array.isArray(options) && options.length > 0;
    });
    var isSelectWithoutOptionsAndCustomDisabled = computed(function () {
      var _editedItem$value7, _editedItem$value8;
      var isSelectType = [MetricValueKind.Select, MetricValueKind.SingleSelect].includes((_editedItem$value7 = editedItem.value) === null || _editedItem$value7 === void 0 ? void 0 : _editedItem$value7.valueType);
      return isSelectType && !((_editedItem$value8 = editedItem.value) !== null && _editedItem$value8 !== void 0 && _editedItem$value8.allowCustomOptions) && !hasValueOptions.value;
    });
    var changesByKey = computed(function () {
      var obj = {};
      for (var _i2 = 0, _Object$keys2 = Object.keys(editedItem.value); _i2 < _Object$keys2.length; _i2++) {
        var key = _Object$keys2[_i2];
        var changes = [];
        if (key === 'sections') {
          var _props$item$sections, _editedItem$value$key;
          // FIXME this is the only place we need a special handler
          // because I want to ONLY render "section.name" in the changes sections
          // it should still works without this but it will render a huge text block of sections.
          changes = Diff.diffJson(((_props$item$sections = props.item.sections) === null || _props$item$sections === void 0 ? void 0 : _props$item$sections.map(function (s) {
            return s.label;
          })) || '', ((_editedItem$value$key = editedItem.value[key]) === null || _editedItem$value$key === void 0 ? void 0 : _editedItem$value$key.map(function (s) {
            return s.label;
          })) || '').filter(function (c) {
            return c.added || c.removed;
          });
        } else {
          changes = Diff.diffJson(props.item[key] || '', editedItem.value[key] || '').filter(function (c) {
            return c.added || c.removed;
          });
        }
        if (changes.length) {
          obj[key] = changes;
        }
      }
      return obj;
    });
    var isSaveDisabled = computed(function () {
      var hasChanges = Object.keys(changesByKey.value).length === 0;
      var hasMissingMandatoryFields = missingMandatoryFields.value.length > 0;
      return hasChanges || hasMissingMandatoryFields || isSelectWithoutOptionsAndCustomDisabled.value || isConditionsInvalid.value;
    });
    var missingMandatoryFields = computed(function () {
      var _editedItem$value9, _editedItem$value10, _editedItem$value11;
      var normalizeRequiredText = function normalizeRequiredText(value) {
        return typeof value === 'string' ? value.trim() : '';
      };
      var missingFields = [];
      var hasUnitName = normalizeRequiredText((_editedItem$value9 = editedItem.value) === null || _editedItem$value9 === void 0 ? void 0 : _editedItem$value9.unitName) !== '' || normalizeRequiredText(unitNameSearchInput.value) !== '';
      if (!((_editedItem$value10 = editedItem.value) !== null && _editedItem$value10 !== void 0 && _editedItem$value10.valueType)) {
        missingFields.push(proxy.$t('valueType'));
      }
      if (!hasUnitName) {
        missingFields.push(proxy.$t('unit'));
      }
      if (props.isTocImpactCarryContext && !((_editedItem$value11 = editedItem.value) !== null && _editedItem$value11 !== void 0 && _editedItem$value11.tocRelation)) {
        missingFields.push(proxy.$t('tocRelationLabel'));
      }
      return missingFields;
    });
    var nuxt2Context = nuxtApp.nuxt2Context;
    var apolloClient = nuxt2Context === null || nuxt2Context === void 0 ? void 0 : (_nuxt2Context$app = nuxt2Context.app) === null || _nuxt2Context$app === void 0 ? void 0 : (_nuxt2Context$app$apo = _nuxt2Context$app.apolloProvider) === null || _nuxt2Context$app$apo === void 0 ? void 0 : _nuxt2Context$app$apo.defaultClient;
    var formatKPIName = function formatKPIName(item) {
      var _item$assignedTo, _item$name, _item$name2;
      return "".concat(item.id, " ").concat(item.isComputed ? '∑ ' : '📝', " (").concat((_item$assignedTo = item.assignedTo) !== null && _item$assignedTo !== void 0 ? _item$assignedTo : '', ") - ").concat((_item$name = item.name) === null || _item$name === void 0 ? void 0 : _item$name.slice(0, 30)).concat(((_item$name2 = item.name) === null || _item$name2 === void 0 ? void 0 : _item$name2.length) > 30 ? '...' : '');
    };
    var mentionItems = function mentionItems(_ref2) {
      var query = _ref2.query;
      return apolloClient.query({
        query: LIST_METRICS_QUERY,
        variables: {
          input: {
            text: query
          },
          limit: 10
        }
      }).then(function (_ref3) {
        var _data$listMetrics;
        var data = _ref3.data;
        return (data === null || data === void 0 ? void 0 : (_data$listMetrics = data.listMetrics) === null || _data$listMetrics === void 0 ? void 0 : _data$listMetrics.map(function (item) {
          return {
            id: item.id,
            name: formatKPIName(item)
          };
        })) || [];
      }).catch(function (error) {
        // Handle or throw the error as needed
        throw error;
      });
    };
    var handleUpdateReportingPeriodType = function handleUpdateReportingPeriodType(v) {
      editedItem.value = _objectSpread(_objectSpread({}, editedItem.value), {}, {
        defaultReportingPeriodType: v
      }, v !== MetricReportingPeriodType.Annual && {
        allowQuarterlyInput: false
      });
    };
    var annualSumOrAverageDisabled = computed(function () {
      return ![MetricValueKind.Float, MetricValueKind.Int].includes(editedItem.value.valueType);
    });
    var unitPresets = ['USD', 'EUR', '%', 'tonnes', 'tonnes CO2e', 'GWh', 'MWh', 'kWh', 'kg', 't', 'm²', 'm³', 'FTE', 'employees', 'people'];
    var isAggregationMethodAdminOnly = computed(function () {
      var isPublicComputedAggregation = editedItem.value.isComputed && (!editedItem.value.assignedTo || editedItem.value.assignedTo === TypeMetricAssignedTo.Fund);
      return !isPublicComputedAggregation;
    });
    var aggregationMethodItems = computed(function () {
      return [{
        text: MetricAggregationMethod.Sum,
        value: MetricAggregationMethod.Sum
      }, {
        text: MetricAggregationMethod.Avg,
        value: MetricAggregationMethod.Avg
      }, {
        text: proxy.$t('percentageOfYesTrue'),
        value: MetricAggregationMethod.SumOverLen
      }, null];
    });
    var tocRelationItems = computed(function () {
      return [{
        text: proxy.$t('tocRelationSolutions'),
        value: 'SOLUTIONS_OUTPUT'
      }, {
        text: proxy.$t('tocRelationOutcome'),
        value: 'OUTCOME'
      }, {
        text: proxy.$t('tocRelationImpact'),
        value: 'IMPACT_LONG_TERM'
      }];
    });
    var handleAssignedToChange = function handleAssignedToChange(v) {
      editedItem.value = _objectSpread(_objectSpread({}, editedItem.value), {}, {
        assignedTo: v
      });
    };
    var handleValueTypeChange = function handleValueTypeChange(v) {
      editedItem.value = _objectSpread(_objectSpread({}, editedItem.value), {}, {
        valueType: v
      });
    };
    var handleAnnualAggregationMethodChange = function handleAnnualAggregationMethodChange(v) {
      editedItem.value = _objectSpread(_objectSpread({}, editedItem.value), {}, {
        annualAggregationMethod: v
      });
    };
    watch(function () {
      return editedItem.value.allowQuarterlyInput;
    }, function (allowQuarterlyInput) {
      if (allowQuarterlyInput === true) {
        editedItem.value = _objectSpread(_objectSpread({}, editedItem.value), {}, {
          annualAggregationMethod: AnnualAggregationMethod.Sum
        });
      }
    });
    var handleUpdateIsComputed = function handleUpdateIsComputed(v) {
      editedItem.value = _objectSpread(_objectSpread({}, editedItem.value), {}, {
        isComputed: v
      }, v === true && {
        allowQuarterlyInput: false,
        defaultReportingPeriodType: MetricReportingPeriodType.Annual,
        annualAggregationMethod: AnnualAggregationMethod.MostRecent
      });
    };
    return {
      __sfc: true,
      showDebugging: showDebugging,
      nuxtApp: nuxtApp,
      proxy: proxy,
      userResult: userResult,
      user: user,
      showAdmins: showAdmins,
      props: props,
      kpiEditTitle: kpiEditTitle,
      emit: emit,
      editedItem: editedItem,
      useJsonEditorForValueOptions: useJsonEditorForValueOptions,
      unitNameSearchInput: unitNameSearchInput,
      setDefaults: setDefaults,
      mutate: mutate,
      isJsonString: isJsonString,
      isConditionsInvalid: isConditionsInvalid,
      updateCategoryId: updateCategoryId,
      save: save,
      sectionResult: sectionResult,
      allSections: allSections,
      formulaInHtml: formulaInHtml,
      formulaErr: formulaErr,
      validate: validate,
      validatedFormula: validatedFormula,
      onFormulaInput: onFormulaInput,
      isCalculatedWithoutFormula: isCalculatedWithoutFormula,
      showAnnualAggregationMethodWarning: showAnnualAggregationMethodWarning,
      hasValueOptions: hasValueOptions,
      isSelectWithoutOptionsAndCustomDisabled: isSelectWithoutOptionsAndCustomDisabled,
      changesByKey: changesByKey,
      isSaveDisabled: isSaveDisabled,
      missingMandatoryFields: missingMandatoryFields,
      nuxt2Context: nuxt2Context,
      apolloClient: apolloClient,
      formatKPIName: formatKPIName,
      mentionItems: mentionItems,
      handleUpdateReportingPeriodType: handleUpdateReportingPeriodType,
      annualSumOrAverageDisabled: annualSumOrAverageDisabled,
      unitPresets: unitPresets,
      isAggregationMethodAdminOnly: isAggregationMethodAdminOnly,
      aggregationMethodItems: aggregationMethodItems,
      tocRelationItems: tocRelationItems,
      handleAssignedToChange: handleAssignedToChange,
      handleValueTypeChange: handleValueTypeChange,
      handleAnnualAggregationMethodChange: handleAnnualAggregationMethodChange,
      handleUpdateIsComputed: handleUpdateIsComputed,
      MetricValueKind: MetricValueKind,
      TypeMetricAssignedTo: TypeMetricAssignedTo,
      AnnualAggregationMethod: AnnualAggregationMethod,
      MetricReportingPeriodType: MetricReportingPeriodType,
      renderMarkdown: renderMarkdown
    };
  }
});